"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTextSelection = void 0;
var react_1 = require("react");
function roundValues(_rect) {
    var rect = __assign({}, _rect);
    for (var _i = 0, _a = Object.keys(rect); _i < _a.length; _i++) {
        var key = _a[_i];
        // @ts-ignore
        rect[key] = Math.round(rect[key]);
    }
    return rect;
}
function shallowDiff(prev, next) {
    if (prev != null && next != null) {
        for (var _i = 0, _a = Object.keys(next); _i < _a.length; _i++) {
            var key = _a[_i];
            if (prev[key] != next[key]) {
                return true;
            }
        }
    }
    else if (prev != next) {
        return true;
    }
    return false;
}
var defaultState = {};
/**
 * useTextSelection(ref)
 *
 * @description
 * hook to get information about the current text selection
 *
 */
function useTextSelection(target) {
    var _a = react_1.useState(defaultState), _b = _a[0], clientRect = _b.clientRect, isCollapsed = _b.isCollapsed, textContent = _b.textContent, setState = _a[1];
    var reset = react_1.useCallback(function () {
        setState(defaultState);
    }, []);
    var handler = react_1.useCallback(function () {
        var newRect;
        var selection = window.getSelection();
        var newState = {};
        if (selection == null || !selection.rangeCount) {
            setState(newState);
            return;
        }
        var range = selection.getRangeAt(0);
        if (target != null && !target.contains(range.commonAncestorContainer)) {
            setState(newState);
            return;
        }
        if (range == null) {
            setState(newState);
            return;
        }
        var contents = range.cloneContents();
        if (contents.textContent != null) {
            newState.textContent = contents.textContent;
        }
        var rects = range.getClientRects();
        if (rects.length === 0 && range.commonAncestorContainer != null) {
            var el = range.commonAncestorContainer;
            newRect = roundValues(el.getBoundingClientRect().toJSON());
        }
        else {
            if (rects.length < 1)
                return;
            newRect = roundValues(rects[0].toJSON());
        }
        if (shallowDiff(clientRect, newRect)) {
            newState.clientRect = newRect;
        }
        newState.isCollapsed = range.collapsed;
        setState(newState);
    }, [target]);
    react_1.useLayoutEffect(function () {
        document.addEventListener('selectionchange', handler);
        document.addEventListener('keydown', handler);
        document.addEventListener('keyup', handler);
        window.addEventListener('resize', handler);
        return function () {
            document.removeEventListener('selectionchange', handler);
            document.removeEventListener('keydown', handler);
            document.removeEventListener('keyup', handler);
            window.removeEventListener('resize', handler);
        };
    }, [target]);
    return {
        clientRect: clientRect,
        isCollapsed: isCollapsed,
        textContent: textContent
    };
}
exports.useTextSelection = useTextSelection;
